import { FC } from "react";
import { StagingScanModal } from "./StagingScanModal";
import { StagingScanErrorModal, StagingScanErrorModalProps } from "./StagingScanErrorModal";

export const stagingScanModalMap: Record<StagingScanModal, FC<StagingScanErrorModalProps>> = {
  [StagingScanModal.GAYLORD_NOT_FOUND]: StagingScanErrorModal,
  [StagingScanModal.UNKNOWN_ERROR]: StagingScanErrorModal,
};

export const stagingScanMessageMap: Record<StagingScanModal, StagingScanErrorModalProps> = {
  [StagingScanModal.GAYLORD_NOT_FOUND]: {
    title: "Gaylord not found",
    text: "The gaylord scanned is not valid. Please check the barcode and try again.",
    hideModalValue: StagingScanModal.GAYLORD_NOT_FOUND,
  },
  [StagingScanModal.UNKNOWN_ERROR]: {
    title: "Unknown error",
    text: "An unknown error occurred. Please try again. Contact a supervisor if the issue persists.",
    hideModalValue: StagingScanModal.UNKNOWN_ERROR,
  },
};
